import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import wordsToNumbers from 'words-to-numbers';
import alanBtn from '@alan-ai/alan-sdk-web';
import { NewsCards, Modal } from './components';
import useStyles from './styles';
import * as ReactBootStrap from 'react-bootstrap'

const App = () => {
  const [activeArticle, setActiveArticle] = useState(0);
  const [newsArticles, setNewsArticles] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    alanBtn({
      key: '0f4561ecd06f3d7e281f99ef942d35762e956eca572e1d8b807a3e2338fdd0dc/stage',
      onCommand: ({ command, articles, number }) => {
        if (command === 'newHeadlines') {
          setNewsArticles(articles);
          setActiveArticle(-1);
        } else if (command === 'instructions') {
          setIsOpen(true);
        } else if (command === 'highlight') {
          setActiveArticle((prevActiveArticle) => prevActiveArticle + 1);
        } else if (command === 'open') {
          const parsedNumber = number.length > 2 ? wordsToNumbers((number), { fuzzy: true }) : number;
          const article = articles[parsedNumber - 1];

          if (parsedNumber > articles.length) {
            alanBtn().playText('Please try that again...');
          } else if (article) {
            window.open(article.url, '_blank');
            alanBtn().playText('Opening...');
          } else {
            alanBtn().playText('Please try that again...');
          }
        }
      },
    });
  }, []);

  return (
    <div>
      <ReactBootStrap.Navbar bg="" expand="lg">
  <ReactBootStrap.Container>
    <ReactBootStrap.Navbar.Brand href="#index.js" color="red"  >Ai Assistant</ReactBootStrap.Navbar.Brand>
    <ReactBootStrap.Navbar.Toggle aria-controls="basic-navbar-nav" />
    <ReactBootStrap.Navbar.Collapse id="basic-navbar-nav">
      <ReactBootStrap.Nav className="me-auto">
        <ReactBootStrap.Nav.Link href="#home">Home</ReactBootStrap.Nav.Link>
        <ReactBootStrap.Nav.Link href="https://mega.nz/file/OAswEbbb#2_H4Qos42SEmGevQ4P-74yFV_yyNVcT4sDT1ZyDjKEU" target="_blank">document</ReactBootStrap.Nav.Link>
        <ReactBootStrap.NavDropdown title="More Info" id="basic-nav-dropdown" >
          <ReactBootStrap.NavDropdown.Item href="https://github.com/Fahdlabba" target="_blank">github</ReactBootStrap.NavDropdown.Item>
            <ReactBootStrap.NavDropdown.Divider />
          <ReactBootStrap.NavDropdown.Item href="https://www.linkedin.com/feed/" target="_blank">Linkdin</ReactBootStrap.NavDropdown.Item>
            <ReactBootStrap.NavDropdown.Divider />
          <ReactBootStrap.NavDropdown.Item href="#action/3.3" target="_blank">E-mail</ReactBootStrap.NavDropdown.Item>
        </ReactBootStrap.NavDropdown>
      </ReactBootStrap.Nav>
    </ReactBootStrap.Navbar.Collapse>
  </ReactBootStrap.Container>
</ReactBootStrap.Navbar>
      {/*<div className={classes.logoContainer}>
        {newsArticles.length ? (
          <div className={classes.infoContainer}>
            <div className={classes.card}><Typography variant="h9" component="h4">Try saying: <br /><br />Open article number [4]</Typography></div>
            <div className={classes.card}><Typography variant="h9" component="h4">Try saying: <br /><br />Go back</Typography></div>
          </div>
        ) : null}
        </div>*/}
        {/*<img src={logo} className={classes.alanLogo} alt="logo" />*/}
      <NewsCards articles={newsArticles} activeArticle={activeArticle} />
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} />
      {!newsArticles.length ? (
        <div className={classes.footer}>
          <Typography variant="body1" component="h2">
            <strong>©-2021-Created by</strong>
            <a className={classes.link} href="https://www.facebook.com/profile.php?id=100027275971238" target="_blank"> Fahd Labba</a>
            
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default App;